import { render, staticRenderFns } from "./ConfirmRemoveAiAccommodation.vue?vue&type=template&id=e60de346&scoped=true"
import script from "./ConfirmRemoveAiAccommodation.vue?vue&type=script&lang=js"
export * from "./ConfirmRemoveAiAccommodation.vue?vue&type=script&lang=js"
import style0 from "./ConfirmRemoveAiAccommodation.vue?vue&type=style&index=0&id=e60de346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60de346",
  null
  
)

export default component.exports